/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import NotificationBell from "../../../../components/Notification/NotificationBell";
import SecondaryLargeButton from "../../../../components/_utils/CommonButtons/SecondaryLargeButton/SecondaryLargeButton";
import TertiaryTopRoundButton from "../../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import CommonCardDashboard from "../../../../components/_utils/CommonCardDashboard";
import { ReimburseViewAll } from "../../../../redux/features/accounts/ReimburseAccount";
import { resetToggle } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { resetServices } from "../../../../redux/features/refreshToken/refreshToken";
import {
  resetInEdit,
  resetIsCreateAcc,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import "./index.css";
import useInitials from "../../../../utils/useInitials";

const ReimbursementDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initials = useInitials();

  const { ReimburseViewAllData, ReimburseViewAllLoading } = useSelector(
    (state) => state.ReimburseAccount,
  );
  const approvalCount = ReimburseViewAllData?.summary?.approved_accounts_count;
  const pendingCount = ReimburseViewAllData?.summary?.pending_accounts_count;
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const onMount = () => {
    dispatch(
      ReimburseViewAll({
        page: GlobalConfiguration.lengthCheckOne,
        page_size: PaginationConfiguration.paginationMid,
      }),
    );
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  const handleDatacardClick = (approvalStatus) => {
    const routeMap = {
      approved:
        "/reimbursement_account_dashboard/reimbursement_account_view_all",
      pending:
        services.includes("RAAccount") || services?.includes("Admin")
          ? "/reimbursement_account_dashboard/reimbursement_account_approval"
          : services.includes("RVAccount") ||
              services?.includes("Admin") ||
              services.includes("RAAccount")
            ? "/reimbursement_account_dashboard/reimbursement_account_view_all"
            : navigate("/feature_not_assigned", {
                state: {
                  unavailableService: "RAAccount",
                },
              }),
    };
    dispatch(resetToggle());
    navigate(routeMap[approvalStatus], {
      state: { approvalStatus },
    });
  };

  return (
    <div className=" internalDashboardView bg-primary-bg w-width-full px-padding-md overflow-y-auto pb-padding-md h-screen ">
      <div className="Qsmd:h-navbar-breadcrumb-height"></div>
      <div className="flex flex-col gap-gap-md mt-margin-md lg:mx-auto pb-padding-xl lg:pb-padding-base max-w-tab-width-normal w-width-full lg:flex-row mb-margin-xl lg:mb-margin-base Qlg:relative">
        <div className="lg:w-dashboard-left-card-width">
          <div className="w-width-full flex flex-col pt-padding-md Qsmd:pt-padding-base mt-margin-xl Qsmd:mt-margin-base ">
            <div className="Qsmd:hidden w-width-full fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center justify-between z-z-index-fixed-ui rounded-b-border-radius-sm h-[var(--home-nav-mobile-height)] pl-mobile-padding-l pr-mobile-padding-l border-b border-primary-bg shadow-sm">
              <div className="flex items-center">
                <img
                  src={ICONS?.XPENTRA_BLUE}
                  alt="Xpentra Logo"
                  className="w-xpentra-logo-width h-xpentra-logo-height"
                />
              </div>
              <div className="flex gap-gap-sm flex-row items-center ">
                <NotificationBell />
                <div className="w-px h-5 bg-primary-card mx-2"></div>
                <div
                  className="text-xs bg-text-secondary text-primary-bg h-[var(--profile-initials-w-h)] w-[var(--profile-initials-w-h)] flex items-center justify-center rounded-full font-semibold cursor-pointer"
                  onClick={() => navigate("/home/profile_quick_menu")}
                >
                  {initials}
                </div>
              </div>
            </div>
            <div className="w-width-full bg-primary-nav flex flex-col sm:flex-row rounded-border-radius-md items-center z-z-index-header mb-margin-md">
              <div className="w-width-full flex">
                <SecondaryLargeButton
                  btnText="Create reimbursement account"
                  btnType="button"
                  handleFunction={() => {
                    const requiredService = "RUAccount";
                    if (services?.includes(requiredService)) {
                      dispatch(resetInEdit());
                      navigate(
                        "/reimbursement_account_dashboard/create_reimbursement_account",
                      );
                      dispatch(resetServices());

                      dispatch(resetIsCreateAcc());
                    } else {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: requiredService },
                      });
                    }
                  }}
                  isDisabled={
                    !(
                      services?.includes("RUAccount") ||
                      services?.includes("Admin")
                    )
                  }
                  enabledTextColor="var(--text-primary)"
                  disabledTextColor="var(--text-secondary)"
                  enabledBgColor="var(--primary-nav)"
                  hoverOption="white"
                  isLoaderNeeded={false}
                  isLoading={false}
                  icon={ICONS?.ADD_BUTTON_WHITE}
                  imgColor="var(--text-primary)"
                  iconAlt="add_button_white"
                />
              </div>
            </div>
            <div className="w-width-full rounded-border-radius-md relative overflow-hidden">
              <h2 className="bg-primary-card flex items-center justify-between pl-padding-md transition-all duration-animation-medium">
                <div className="flex items-center gap-gap-sm">
                  <img
                    src={ICONS?.APPROVAL_STATUS}
                    alt="transaction header"
                    className="w-icon-sm h-icon-sm"
                  />
                  <p className="text-font-sm font-semibold font-sans text-text-primary">
                    Account Statuses
                  </p>
                </div>
                <div className="flex">
                  <div className="border-dividing"></div>
                  <TertiaryTopRoundButton
                    btnText="View all"
                    icon={ICONS?.ARROW_RIGHT_WHITE}
                    imgColor="var(--text-primary)"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={async () => {
                      await dispatch(resetToggle());
                      if (
                        ReimburseViewAllData?.total_count ===
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        return;
                      } else if (
                        services?.includes("RVAccount") ||
                        services?.includes("Admin")
                      ) {
                        navigate(
                          "/reimbursement_account_dashboard/reimbursement_account_view_all",
                          {
                            state: { approvalStatus: "all" },
                          },
                        );
                      } else if (
                        !services?.includes("RVAccount") ||
                        !services?.includes("Admin")
                      ) {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "RVAccount" },
                        });
                      }
                    }}
                    isDisabled={
                      ReimburseViewAllLoading ||
                      !services?.includes("RVAccount") ||
                      ReimburseViewAllData?.total_count ===
                        GlobalConfiguration.lengthCheckZero
                    }
                    isLoading={ReimburseViewAllLoading}
                    enabledTextColor={"var(--text-primary)"}
                    disabledTextColor={"var(--text-secondary)"}
                    enabledBgColor={"var(--primary-card)"}
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "RVAccount" },
                      })
                    }
                  />
                </div>
              </h2>
              <div>
                <div className="flex flex-col Qsmd:flex-row gap-gap-base p-padding-base bg-primary-nav  ">
                  <CommonCardDashboard
                    label={
                      services?.includes("RAAccount") ||
                      services?.includes("Admin")
                        ? "Require approval"
                        : "Pending accounts"
                    }
                    count={
                      services?.includes("RVAccount")
                        ? (pendingCount ??
                          GlobalConfiguration.dashboardPrimaryCount)
                        : "N/A"
                    }
                    color="var(--pending)"
                    loader={ReimburseViewAllLoading}
                    onClick={() => handleDatacardClick("pending")}
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "RVAccount" },
                      })
                    }
                  />
                  <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base"></div>
                  <CommonCardDashboard
                    label="Approved accounts"
                    color="var(--awaiting)"
                    count={
                      services?.includes("RVAccount")
                        ? (approvalCount ??
                          GlobalConfiguration.dashboardPrimaryCount)
                        : "N/A"
                    }
                    loader={ReimburseViewAllLoading}
                    onClick={() => handleDatacardClick("approved")}
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "RVAccount" },
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="w-width-full mt-margin-md bg-primary-card rounded-t-border-radius-md rounded-b-border-radius-md">
              <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
                <span className="flex items-center text-sm font-semibold text-text-primary ">
                  <img
                    src={ICONS?.STATISTICS}
                    alt="Statistics Header"
                    className="w-icon-sm h-icon-sm mr-margin-sm"
                  />
                  Statistics
                </span>
              </h2>
              <div className="border-border border-primary-bg mx-margin-md"></div>

              <div className="relative w-width-full lg:py-padding-md overflow-hidden contents lg:block ">
                <div className="flex flex-col items-center justify-center lg:justify-start h-height-full text-center p-padding-md">
                  <div className="flex flex-col justify-center items-center w-width-full">
                    <img
                      src={ICONS?.NO_STATISTICS_AVAILABLE}
                      alt="No Slides"
                      className="mb-margin-sm w-graphic-width-md h-graphic-rectangle-height-md flex-shrink-0"
                    />
                    <p className="text-font-xs text-text-primary">
                      No statistics available due to the absence of data.
                      <br />
                      Once data is present,statistics will appear.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-dashboard-right-card-width">
          {/* <CommonMoreActionsCard
            title="More actions"
            actions={[
              {
                label: "MIS report",
               service: "SMisUser",
                onClick: () => {
                  if (services?.includes("SMisUser")) {
                    navigate(
                      "/reimbursement_account_dashboard/generate_mis_report",
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "SMisUser",
                      },
                    });
                  }
                },
              },
            ]}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default ReimbursementDashboard;
